import { useState, useRef, useLayoutEffect, forwardRef } from "react";

export const EngineeringCredit = forwardRef<HTMLAnchorElement>((_, ref) => {
  const [isHovered, setIsHovered] = useState(false);
  const shortRef = useRef<HTMLSpanElement>(null);
  const longRef = useRef<HTMLSpanElement>(null);
  const [widths, setWidths] = useState({ short: 0, long: 0 });

  // Measure the actual rendered width of each label (accounts for responsive
  // font size + letter-spacing) so the morphing box fits its text exactly and
  // the credit stays horizontally centered in both the default and hover state.
  useLayoutEffect(() => {
    const measure = () => {
      if (shortRef.current && longRef.current) {
        setWidths({
          short: shortRef.current.offsetWidth,
          long: longRef.current.offsetWidth,
        });
      }
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  return (
    <a
      ref={ref}
      href="https://www.vesper-marketing.com"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center font-bold text-white/75 uppercase tracking-[0.1em] sm:tracking-[0.2em] text-[9px] sm:text-[10px] hover:text-white transition-colors duration-300 whitespace-nowrap"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span>Engineered by</span>
      <span
        className="relative ml-1.5 overflow-hidden inline-flex items-center"
        style={{
          width: (isHovered ? widths.long : widths.short) || "auto",
          height: "1.4em",
          transition: "width 300ms ease-in-out",
        }}
      >
        {/* Hidden measurers (same inherited font + tracking) */}
        <span ref={shortRef} aria-hidden className="invisible absolute whitespace-nowrap">VM</span>
        <span ref={longRef} aria-hidden className="invisible absolute whitespace-nowrap">Vesper Marketing</span>

        <span
          className="absolute inset-0 flex items-center justify-center"
          style={{
            transform: isHovered ? "translateY(-100%)" : "translateY(0)",
            opacity: isHovered ? 0 : 1,
            transition: "transform 300ms ease-in-out, opacity 300ms ease-in-out",
            willChange: "transform, opacity",
            backfaceVisibility: "hidden",
          }}
        >
          VM
        </span>
        <span
          className="absolute inset-0 flex items-center justify-center whitespace-nowrap"
          style={{
            color: "#8B5CF6",
            transform: isHovered ? "translateY(0)" : "translateY(100%)",
            opacity: isHovered ? 1 : 0,
            transition: "transform 300ms ease-in-out, opacity 300ms ease-in-out",
            willChange: "transform, opacity",
            backfaceVisibility: "hidden",
          }}
        >
          Vesper Marketing
        </span>
      </span>
    </a>
  );
});

EngineeringCredit.displayName = 'EngineeringCredit';
